<mat-form-field [formGroup]="chipsForm" appearance="outline" class="width-match-parent">
  <mat-label>{{ label | translate }}</mat-label>
  <mat-error>{{ error | translate }}</mat-error>
  <mat-chip-grid #chipList>
    @for (chip of selectedChips; track chip) {
      <mat-chip-row (removed)="onRemoveChip(chip)"
        >{{ chip.name.de }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      #chipsInput
      (matChipInputTokenEnd)="onChipInputEnd($event)"
      [formControl]="autoCompleteControl"
      [matAutocomplete]="auto"
      [matChipInputAddOnBlur]="addOnBlur"
      [matChipInputFor]="chipList"
      [placeholder]="'PROFILE.FORM.find_institution_label' | translate"
      matInput
      />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onChipSelected($event)">
    @for (option of chipOptions$ | async; track option) {
      <mat-option [value]="option">
        {{ displayValue(option) }}
      </mat-option>
    }
    @if (nothingFoundTip) {
      <mat-option disabled>{{
        'PROFILE.FORM.nothing_found' | translate
      }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
